import { markRepoAuctionStatusTo } from "../repoChargesApprove/repoChargesApproval";

export const approveOrRejectRepoAuction: any = (recordId:  string, data:any, args: any[]) => {
  data["status"] = args[1];
  return markRepoAuctionStatusTo(recordId, args[0], data, "Successfully "+args[1]+" the  repoKit:"+recordId);
}
